import { useState } from "react";

import clsx from "clsx";

import nbGlobe from "@assets/northbeam-globe.png";
import { Modal } from "@shared/modal";

import PlatformIcon from "../../components/platform-icon";
import { type Platform } from "../../constants";

export const VideoContent = ({
  videoUrl,
  title,
  platform,
}: {
  videoUrl: string;
  title: string;
  platform: Platform;
}) => {
  const [play, setPlay] = useState(false);
  return (
    <>
      <Modal
        isOpen={play}
        onClose={() => {
          setPlay(false);
        }}
        size="xl"
      >
        <iframe
          src={videoUrl}
          title={title}
          width="100%"
          height="500"
          frameBorder="0"
          className="mt-2"
        />
      </Modal>
      <div className="flex rounded-xl w-full h-[180px]">
        <div className="w-[20rem] h-full relative">
          <>
            <i
              className={clsx(
                "fa-regular fa-sharp fa-circle-play absolute text-[3rem] text-white",
                "left-[50%] top-[50%] z-[1] py-[0.5rem] px-[0.5rem] hover:text-interstellar",
                "cursor-pointer",
              )}
              style={{ transform: "translate(-50%, -50%)" }}
              onClick={() => setPlay(true)}
            />
            <img
              className="w-full h-full"
              alt="benchmark-marketing-logo"
              src={nbGlobe}
            />
          </>
        </div>
        <div className="flex-1 bg-interstellar p-6 rounded-r">
          <div className="h-full flex flex-col my-1.5 max-w-[480px] justify-between">
            <PlatformIcon platform={platform} />
            <div>
              <h1 className="heading mx-0 mb-0 mt-0 text-white text-2xl font-semibold leading-loose">
                {title}
              </h1>
              <span className="text-lg text-white">Northbeam</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
